import React from 'react';
import { observer } from 'mobx-react';
import Icon from '../../../../../components/Icon';
import cx from 'classnames';
import * as Duration from 'dration';
import styles from './CallPromptInfo.m.sass';
import { formatDuration } from '../../../../../utils/dateUtil';
import { CallStatus } from '../../../Call';
import CallEndCallIcon from 'assets/icons/call-end-call.i.svg';
import IconSvg from '../../../../../components/IconSvg';
import { CallOperatorState } from '../../../constants';
var timeFormatter = new Intl.DateTimeFormat('en-US', {
  hour12: true,
  hour: 'numeric',
  minute: 'numeric'
});
export var CallStatusInfo = observer(function CallStatusInfo(_ref) {
  var vm = _ref.vm,
    _ref$operatorState = _ref.operatorState,
    operatorState = _ref$operatorState === void 0 ? null : _ref$operatorState;
  var icon = null;
  var title = 'Call';
  var subtitle;
  var ended = false;
  var otherParticipants = vm.call.otherParticipants;
  var durationText = formatDuration(vm.duration, 'long', 'a few seconds');
  switch (vm.call.callStatus) {
    case CallStatus.InProgress:
      {
        icon = /*#__PURE__*/React.createElement(Icon, {
          name: "phone"
        });
        if (operatorState === CallOperatorState.Connected) {
          title = 'Call Started';
          subtitle = "".concat(Duration.format(vm.duration));
          break;
        }
        title = operatorState === CallOperatorState.Incoming && otherParticipants.length === 1 ? "".concat(otherParticipants[0].member.displayName, " is calling you...") : 'Call Started';
        subtitle = "Started ".concat(durationText, " ago");
        break;
      }
    case CallStatus.Completed:
      {
        var _vm$call$dateComplete;
        icon = /*#__PURE__*/React.createElement(IconSvg, {
          size: 24
        }, /*#__PURE__*/React.createElement(CallEndCallIcon, null));
        title = 'Call Ended';
        subtitle = "Ended at ".concat(timeFormatter.format((_vm$call$dateComplete = vm.call.dateCompleted) !== null && _vm$call$dateComplete !== void 0 ? _vm$call$dateComplete : undefined), " \u2014 Lasted ").concat(durationText);
        ended = true;
        break;
      }
    case CallStatus.Unknown:
      {
        icon = /*#__PURE__*/React.createElement(Icon, {
          name: "info"
        });
        title = 'Unknown Call Status';
        subtitle = "This is a bit odd.";
        break;
      }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.iconContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles.iconBox, ended && styles.ended)
  }, icon)), /*#__PURE__*/React.createElement("div", {
    className: styles.text
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, title), /*#__PURE__*/React.createElement("div", {
    className: styles.subtitle
  }, subtitle)));
});
//# sourceMappingURL=index.js.map
